import { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";
import FormButton from "../../../../_shoru_shared_library/components/form/FormButton";
import { createGroup, getBookedAuditionees } from "../../../../CastingBotFirebase";
import SectionLoader from "../../../../_shoru_shared_library/loaders/SectionLoader";
import FormSelect from "../../../../_shoru_shared_library/components/form/FormSelect";

function AddGroupTab(props) {

  function filterForRecalls(x) {return x.recalled}

  const userData = props.userData;
  const castingData = props.extraData;
  const setCastingData = props.setExtraData;

  const roles = castingData.roles;
  const [recallees, setRecallees] = useState(null)
  const [data, setData] = useState([{recallee_id: null, role_id: null, form_id: 0}])
  const [log, setLog] = useState([]);

  // Get auditionee data
  useEffect(() => {
    getBookedAuditionees(castingData.slots.filter(filterForRecalls), userData.active_organisation_id, setRecallees);
    // eslint-disable-next-line
  }, []);

  if(recallees === null) return <SectionLoader />


  const logDisplay = log.map((item, index) => {
    return (
      <p key={index} style={{
        ...{marginTop: '0'},
        ...{marginBottom:'0'},
        ...{color:'#2ecc71'},
        ...{fontSize: '12px'}
      }}>
        {item}
      </p>
    )
  })

  const recalleeOptions = recallees.map((recallee) => {
    return <option value={recallee.uid}>{recallee.name}</option>
  })

  const roleOptions = roles.map((role) => {
    return <option value={role.id}>{role.name}</option>
  })

  const formDisplay = data.map((individual, index) => {
    return (
      <div>
        <FormSelect required addNull title='Name' value={individual.recallee_id} setValue={(x) => {
            data[index].auditionee_id = x;
            setData(data);
          }} >
          {recalleeOptions}
        </FormSelect>
        <FormSelect required addNull title='Role' value={individual.role_id} setValue={(x) => {
            data[index].role_id = x;
            setData(data);
          }} >
          {roleOptions}
        </FormSelect>
        {index === data.length - 1? (
          <div>
            {index !== 0? (
              <FormButton gap bordered label={'Remove member'} accentColour={'#e74c3c'} onClick={() => {
                setData(data.filter((x) => {return x.form_id !== individual.form_id}))
              }} />
            ) : null}
            <FormButton gap bordered label={'Add another member to group'} accentColour={props.accentColour} onClick={() => {
              setData([...data, {recallee_id: null, role_id: null, form_id: uuidv4()}])
            }} />
            <FormButton label={'Create Group [' + data.length + ' member' + (data.length !== 1? 's' : '') + ']'} accentColour={props.accentColour} onClick={async() => {
              const newData = _validateAndGetData(data);
              if(newData !== null)
              {
                await createGroup(data, userData.active_organisation_id, castingData.uid, setCastingData).then(() => {
                  var names = ''
                  data.forEach((item, index) => {
                    recallees.map((recallee) => {
                      if(recallee.uid === item.auditionee_id) {
                        names += ' ' + recallee.name + (index === data.length - 1? '' : ',');
                      }
                    })
                  })
                  setLog([('Created Group: ' + names),...log]);
                });
              }
            }} />
          </div>
        ) : null}
        {index !== data.length - 1? (<hr style={{...{width: '100%'},...{marginTop: '50px'},...{marginBottom: '50px'}}} />) : null }
      </div>
    )
  })

  return (
    <SubTabParent passData={props}>
      <SubTabSection title='Create Group' description='Auditionees must be moved to your recall pool before you can add them to groups'>
        {formDisplay}
        {logDisplay}
      </SubTabSection>
    </SubTabParent>
  )

}

export default AddGroupTab;


const _validateAndGetData = (data) => {

  var valid = true;
  data.forEach((item) => {
    if(item.auditionee_id === null || item.role_id === null)
    {
      alert('You must fill out all required fields');
      valid = false;
    }
  });

  if(valid) return data;
  else return null;
}